import { Button, Card, EmptyState, Skeleton } from '@ui/themed';
import { t } from 'i18next';
import type { PropsWithChildren } from 'react';

// Handles loading and error states
export function SparkSuspense(
  props: PropsWithChildren<{
    isError: boolean;
    errorMessage: string;
    onReload: () => void;
    isLoading: boolean;
  }>,
) {
  if (props.isError) {
    return (
      <Card>
        <EmptyState
          title={t('titles:error_page')}
          imageType="errorState"
          subtitle={props.errorMessage}
        >
          <Button onClick={props.onReload} variant="secondary" icon="refresh">
            {t('buttons:reload')}
          </Button>
        </EmptyState>
      </Card>
    );
  }

  if (props.isLoading) {
    return <Skeleton />;
  }

  return props.children;
}
